import { createContext } from 'react';
import QueueTreatmentContextPropTypes from './QueueTreatmentContextPropTypes';
import queueTreatmentConfig from './QueueTreatmentConfig';

export default createContext<QueueTreatmentContextPropTypes>(queueTreatmentConfig);
